import type { KyInstance } from 'ky';
import Ky from 'ky';

import { config } from '../config';
import type { FavouriteType } from '../helpers/favourites';

interface Entity {
  id: number;
  collection_id: number;
  entity_id: number;
  type: FavouriteType;
}

export interface FavouritesResponse {
  entities: Entity[];
}

const client = Ky.create({
  prefixUrl: config.collectionsApiHostname,
  credentials: 'include',
});

const getFavourites = (client: KyInstance) => async () => {
  return await client.get(`v1/vgtv/favourites`).json<FavouritesResponse>();
};

const addToFavourites = (client: KyInstance) => async (entityId: string) => {
  return await client
    .post(`v1/vgtv/favourites/entities/${entityId}`)
    .json<FavouritesResponse>();
};

const removeFromFavourites =
  (client: KyInstance) => async (entityId: string) => {
    return await client
      .delete(`v1/vgtv/favourites/entities/${entityId}`)
      .json<FavouritesResponse>();
  };

const createFavouritesApi = (client: KyInstance) => ({
  favourites: {
    getFavourites: getFavourites(client),
    addToFavourites: addToFavourites(client),
    removeFromFavourites: removeFromFavourites(client),
  },
});

const favouritesApi = createFavouritesApi(client);

export default favouritesApi;
